import React from "react";

const Section8 = ({url}) => {
  return (

    <section className="home-section-8">
        <div className="container">

            {/* Heading */}
            <div className="text-center section-header">
            <h2>
                From Complex Problem to <br/><span>Confident Decision</span> in Three Steps
            </h2>
            <p className="section-desc">
                Transforms your most complex challenges into clear, data-backed decisions through a structured AI decision-making process
            </p>
            </div>

            <div className="row d-flex align-items-center justify-content-center">

            {/* Left Steps */}
            <div className="col-lg-6 col-xl-5 col-md-12 steps-col" data-aos="fade-right" data-aos-duration="1000">

                <div className="step-card">
                <div className="step-number"><img src={`${url}images/omnix/sec8/1.png`} alt="" /></div>
                <div className="step-content">
                    <h5>Define Your Problem</h5>
                    <p>
                    Input your problem, set debate parameters, and customize AI personas to match the expertise your challenge demands.
                    </p>
                </div>
                </div>

                <div className="step-card">
                <div className="step-number"><img src={`${url}images/omnix/sec8/2.png`} alt="" /></div>
                <div className="step-content">
                    <h5>AI Personas Debate</h5>
                    <p>
                    Multiple expert AI personas engage in structured iterative debate rounds, each challenging your problem from a unique perspective.
                    </p>
                </div>
                </div>

                <div className="step-card">
                <div className="step-number"><img src={`${url}images/omnix/sec8/3.png`} alt="" /></div>
                <div className="step-content">
                    <h5>Synthesized Intelligence</h5>
                    <p>
                    The Super Persona synthesizes all debate outputs into one coherent recommendation, validated by human oversight for quality and ethical integrity.
                    </p>
                </div>
                </div>

            </div>

            {/* Right Video */}
            <div className="col-lg-6 col-xl-5 col-md-12 video-col" data-aos="fade-left" data-aos-duration="1000">
                <div className="video-wrapper">
                    <video
                    className="demo-video"
                    controls
                    poster={`${url}images/intelihire/sec-7/video-thumb.png`}
                    >
                    <source src={`${url}images/omnix.mp4`} type="video/mp4" />
                    Your browser does not support the video tag.
                    </video>
                </div>
                <p className="watch-demo">Watch Demo</p>
            </div>

            </div>
        </div>
    </section>
  );
};

export default Section8;
